import { SchemaType } from "@redotech/redo-model/advanced-flow/schemas/schemas";
import { MarketingChannel } from "@redotech/redo-model/marketing";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const generateSmsAiContentPreview = {
  name: "generateSmsAiContentPreview" as const,
  input: z.object({
    schemaType: createEnum(SchemaType),
    contentGeneratorConfigVersionId: z.string(),
    customerId: z.string().optional(),
    templateId: z.string(), // Add templateId to access template settings
  }),
  output: z.object({
    data: z.object({
      contentPreview: z.string(),
      reasoning: z.string().optional(), // Made optional - backend may not always generate
      channel: createEnum(MarketingChannel),
    }),
  }),
};
